import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { BehaviorSubject, first, shareReplay, switchMap, tap } from 'rxjs';
import { SettingsResource } from './settings.resource';
import type { Settings, UpdateSettingsPayload } from './settings';
import { CurrentUserService } from '@security/user';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  private readonly resource = inject(SettingsResource);
  private readonly currentUser = inject(CurrentUserService);

  public settings$: Observable<Settings>;

  private settingsBus = new BehaviorSubject<void>(undefined);

  public constructor() {
    this.settings$ = this.selectSettings();
  }

  public update(payload: UpdateSettingsPayload) {
    return this.currentUser.ensureUser$.pipe(
      first(),
      switchMap(({ id }) => this.resource.update(id, payload)),
      tap(() => this.refresh()),
    );
  }

  public refresh() {
    this.settingsBus.next();
  }

  private selectSettings() {
    return this.settingsBus.pipe(
      switchMap(() => this.currentUser.ensureUser$.pipe(first())),
      switchMap(({ id }) => this.resource.load(id)),
      shareReplay(1),
    );
  }
}
